"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _colors = require("../../../config/colors");

var _config = require("../../../config/config");

var Instructions = function Instructions(_ref) {
  var hint = _ref.hint,
      handleChange = _ref.handleChange,
      focusActive = _ref.focusActive,
      errorMessages = _ref.errorMessages;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        marginLeft: '0px'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        fontSize: 14,
        fontWeight: 300,
        color: errorMessages && !hint ? '#dc3545' : ''
      }
    }, "Instructions (Optional)",
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Text, {
      className: "text-muted m-0 p-0"
    }, "Use this area to convey any guidance a form filler might need in relation to this field.")),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup, {
      className: "mb-3"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      as: "textarea",
      id: "basic-url-name",
      "aria-describedby": "basic-addon3",
      name: "hint",
      onChange: handleChange,
      value: hint || '',
      placeholder: _config.DEFAULT_PLACE_HOLDER_TEXT,
      style: {
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontSize: 14,
        fontWeight: 300
      },
      className: focusActive.name ? 'focusInputActive' : 'focusInput'
    })))
  );
};

Instructions.defaultProps = {
  hint: '',
  errorMessages: false
};
Instructions.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  hint: _propTypes["default"].string,
  handleChange: _propTypes["default"].func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  focusActive: _propTypes["default"].object.isRequired,
  errorMessages: _propTypes["default"].bool
} : {};

var _default = exports["default"] = Instructions;